
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Search,
  Grid,
  Input,
  Icon,
} from 'semantic-ui-react';
import { flashErrorMessage } from '../actions/flash';
import { fetchM } from '../actions/fetchM';


export default class SearchBranch extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    onSelect: PropTypes.func.isRequired,
    onClear: PropTypes.func.isRequired,
    selectedValue: PropTypes.shape({
      key: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
    }).isRequired,
  }
  static defaultProps = {
    selectedValue: {
      key: 0,
      title: '',
    },
  }
  static getPropsToState = (props) => {
    const value = props.value || '';
    const noResultsMessage = 'Loading...';
    return {
      value,
      noResultsMessage,
    };
  }
  constructor(props) {
    super(props);
    const state = SearchBranch.getPropsToState(props);
    this.state = {
      ...state,
      findBranchesResults: [],
      loading: false,
      showNoResults: true,
      selection: null,
    };
  }
  componentWillReceiveProps(nextProps) {
    const state = SearchBranch.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  componentWillUnmount() {
    if (this.setTimer) {
      clearTimeout(this.setTimer);
    }
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, res);
    });
  }
  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, res);
    });
  }
  async searchBranches(value) {
    await this.setLoading(true);
    const { store } = this.context;
    let res = null;
    try {
      res = await store.dispatch(fetchM(`/search/company_branches/?limit=3&isExternal=false&search=${value}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: 'There was an error with your request. Please try again.' }));
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const json = await res.json();
      if (json) {
        const findBranchesResults = json.map((obj) => {
          const newResults = {};
          newResults.key = obj.id;
          newResults.title = obj.shortName;
          return newResults;
        });
        await this.setComponentState({ findBranchesResults });
      } else {
        const noResultsMessage = 'No results found.';
        await this.setComponentState({ noResultsMessage });
      }
    }
    await this.setLoading(false);
  }
  handleSearchChange = (e, { value }) => {
    clearTimeout(this.setTimer);
    const findBranchesResults = [];
    const showNoResults = true;
    const noResultsMessage = 'Loading...';
    this.setState({ findBranchesResults, noResultsMessage, showNoResults, value }, () => {
      if (value !== '') {
        this.setTimer = setTimeout(() => {
          this.searchBranches(value);
        }, 500);
      }
    });
  }
  handleResultSelect = (e, { result }) => {
    this.setState({
      result,
      value: '',
    }, () => {
      this.props.onSelect(result);
    });
  }
  handleClearSelection = () => {
    this.setState({
      selection: null,
    }, () => {
      this.props.onClear();
    });
  }
  handlerClearValue = () => {
    this.setState({
      value: '',
    });
  }
  render() {
    return (
      <Grid>
        <Grid.Row>
          <Grid.Column width={16}>
            { this.props.selectedValue.key > 0 || this.state.selection ?
              <Grid>
                <Grid.Row>
                  <Grid.Column width={16}>
                    <Input
                      readOnly
                      fluid
                      value={
                        this.props.selectedValue.key > 0
                        ? `${this.props.selectedValue.title}`
                        : `${this.state.selection.title}`
                      }
                      icon={
                        <Icon
                          title="Clear Selection"
                          name="x"
                          onClick={this.handleClearSelection}
                          link
                        />
                      }
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            :
              <Grid>
                <Grid.Row>
                  <Grid.Column width={16}>
                    <Search
                      className="searchlist"
                      fluid
                      icon={
                        <Icon
                          title="Clear Selection"
                          name={this.state.value ? 'x' : 'search'}
                          onClick={this.state.value && this.handlerClearValue}
                          link={!!this.state.value}
                        />
                      }
                      loading={this.state.loading}
                      onResultSelect={this.handleResultSelect}
                      onSearchChange={this.handleSearchChange}
                      results={this.state.findBranchesResults}
                      value={this.state.value}
                      placeholder="Find Business Unit..."
                      noResultsMessage={this.state.noResultsMessage}
                      onFocus={() => {
                        const showNoResults = false;
                        this.setState({ showNoResults });
                      }}
                      showNoResults={this.state.showNoResults}
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            }
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SearchBranch.jsx